import { render, staticRenderFns } from "./Garment.vue?vue&type=template&id=68d1e088&scoped=true&"
import script from "./Garment.vue?vue&type=script&lang=js&"
export * from "./Garment.vue?vue&type=script&lang=js&"
import style0 from "./Garment.vue?vue&type=style&index=0&id=68d1e088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d1e088",
  null
  
)

export default component.exports